@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';

.package-settings-page-header {
  padding: @settings-page--tabbed--header--title-only--padding;
}

.tabs {
  flex: 1;
  overflow: auto;
}

.tabs-body-override {
  overflow: hidden;
  background-color: @settings-page--tabbed--tab-panel--background-color;
}

.tabs-header-override {
  // nesting is necessary to beat specificity of tab component
  .tab-button {
    color: var(--default--text-color--17);
  }

  .selected-tab-button {
    color: var(--default--text-color--17);
    background-color: @settings-page--tabbed--tab-panel--background-color;
    font-weight: 500;
  }
}

.tab-content {
  padding: @settings-page--tabbed--tab-panel--padding;

  & > div {
    margin-bottom: 16px;
  }

  & > div:last-child {
    margin-bottom: 0;
  }
}

.tab-description > p {
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 22px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
